class DurationHelper {
    static SecondsBetween = (start: Date, end: Date): number =>
        Math.floor((end.getTime() - start.getTime()) / 1000);

    // Utils � formatte une dur�e en secondes vers "45 s", "12 min", "3 h 5 min", "2 j 3 h"
    static FormatDuration = (totalSeconds?: number | null) => {
        if (totalSeconds == null || isNaN(totalSeconds as number)) return "";
        const sign = totalSeconds < 0 ? "-" : "";
        const abs = Math.floor(Math.abs(totalSeconds));

        const s = abs % 60;
        const m = Math.floor(abs / 60) % 60;
        const h = Math.floor(abs / 3600) % 24;
        const d = Math.floor(abs / 86400);

        if (abs < 60) return `${sign}${abs} s`;                                                 // < 1 min
        if (abs < 3600) return `${sign}${Math.floor(abs / 60)} min${s ? ` ${s} s` : ""}`;       // < 1 h
        if (abs < 86400) return `${sign}${Math.floor(abs / 3600)} h${m ? ` ${m} min` : ""}`;    // < 1 j
        return `${sign}${d} j${h ? ` ${h} h` : ""}`;                                            // >= 1 j
    };
}

export default DurationHelper;